import styled from '@emotion/styled';
import { Color, ErrorIcon } from '@liveoptics/react-ui';
import React from 'react';

export interface FormErrorProps {
  error: string;
}

const Container = styled.div`
  display: flex;
  font: 600 14px Open Sans;
  letter-spacing: 0.28px;
  color: ${Color.coolGray700};
  background: ${Color.red100} 0% 0% no-repeat padding-box;
  border: 1px solid ${Color.red500};
  padding: 10px 7px;
  align-items: center;
  margin-bottom: 22px;

  svg {
    fill: ${Color.red500};
    color: ${Color.red500};
    margin-right: 10px;
    min-width: 25px;
    min-height: 25px;
  }
`;

export const FormError = (props: FormErrorProps) => {
  return (
    <Container>
      <ErrorIcon />
      <span>{props.error}</span>
    </Container>
  );
};
